export const STRAVA_CONFIG = {
    clientId: process.env.REACT_APP_STRAVA_CLIENT_ID || '24917',
    clientSecret: process.env.REACT_APP_STRAVA_CLIENT_SECRET || 'a8e7d98260f834907e6f35b562e115f021bf3a67',
    redirectUri: window.location.origin + '/callback',
    authUrl: 'https://www.strava.com/oauth/authorize',
    tokenUrl: 'https://www.strava.com/oauth/token',
    scope: 'read,activity:read_all'
}; 